import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useStateAuthValue } from "../context/AuthState";
import { roles } from "../constants/roles";
import ProtectedRoute from "../utils/ProtectedRoute";
// Landing antigua basada en iframe de Metabase (obsoleta). Reemplazada por <Home />.
// import Dashboard from "../pages/dashboard";
import Home from "../pages/home";
import SellerDashboard from "../pages/sellerDashboard";
import Patients from "../pages/patients";
import Financers from "../pages/financers";
import FinancerPlans from "../pages/financerPlans";
import Plans from "../pages/plans";
import Agreements from "../pages/agreements";
import CollapsibleTable from "../pages/socialWork";
import Profetionals from "../pages/profetionals";
import Login from "../pages/login";
import Socio from "../pages/socio";
import NewClientForm from "../pages/newClientForm";
import MySales from "../pages/mySales";
import Reports from "../pages/reports";
import ErrorDatos from "../pages/dataErrors";
import LowMember from "../pages/lowMember";
import RegisterProfessional from "../pages/registerProfessional";
import CollectionsConciliator from "../pages/collectionsConciliator";
import StatusQueue from "../pages/statusQueue";
import PermanencyIndicator from "../pages/permanencyIndicator";
import VoyEnBusReport from "../pages/voyEnBusReport";
import GigaRed from "../pages/gigared";
import Notifications from "../pages/notifications";
import EmailBlacklist from "../pages/emailBlackList";
import BinBlacklist from "../pages/binBlackList";
import CardValidators from "../pages/cardValidators";
import ProfessionalLog from "../pages/professionalLog";
import ChannelsDashboard from "../pages/channelsDashboard";
import SaleTestForm from "../pages/saleTestForm/saleTestForm";
import { SpecialUserView } from "../pages/specialUser/specialUserView";
import MedilineLinkSaleDashboard from "../pages/medilineLinkSaleDashboard";
import GenericDashboard from "../pages/genericDashboard";
import NotFound from "../pages/notFound";
import { genericDashboardRoutes } from "./genericDashboardRoutes";
import Vademecum from "../pages/vademecum";

const AppRouter = () => {
  const [{ userRole }] = useStateAuthValue();

  return (
    <BrowserRouter>
      <Routes>
        {!userRole && (
          <Route
            element={
              <ProtectedRoute>
                <Login />
              </ProtectedRoute>
            }
          />
        )}
         <Route exact path="/socio" element={<Socio />} />
        <Route exact path="/login" element={<Login />} />
        {userRole !== roles.ROLE_USER && (
          <Route
            exact
            path="/"
            element={
              <ProtectedRoute>
                {/* Landing antigua (iframe Metabase obsoleto):
                <Dashboard /> */}
                <Home />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_USER && (
          <Route
            exact
            path="/"
            element={
              <ProtectedRoute>
                <SpecialUserView />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/nuevo-cliente"
            element={
              <ProtectedRoute>
                <NewClientForm />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_SELLER && (
          <Route
            exact
            path="/mis-ventas"
            element={
              <ProtectedRoute>
                <MySales />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_SELLER && (
          <Route
            exact
            path="/nuevo-cliente"
            element={
              <ProtectedRoute>
                <NewClientForm />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/personas/socios"
            element={
              <ProtectedRoute>
                <Patients />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/personas/error"
            element={
              <ProtectedRoute>
                <ErrorDatos />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR &&
          genericDashboardRoutes.map(({ path, title, buttonsList, extraViews }) => (
            <Route
              key={path}
              exact
              path={path}
              element={
                <ProtectedRoute>
                  <GenericDashboard title={title} buttonsList={buttonsList} extraViews={extraViews} />
                </ProtectedRoute>
              }
            />
          ))}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/canales/voyenbus"
            element={
              <ProtectedRoute>
                <VoyEnBusReport />
              </ProtectedRoute>
            }
          />
        )}
        {/* {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/canales/mediline"
            element={
              <ProtectedRoute>
                <MedilineLinkSaleDashboard />
              </ProtectedRoute>
            }
          />
        )} */}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/profesional/registro"
            element={
              <ProtectedRoute>
                <RegisterProfessional />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/profesional/estado-cola"
            element={
              <ProtectedRoute>
                <StatusQueue />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/profesional/active-log"
            element={
              <ProtectedRoute>
                <ProfessionalLog />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/profesional/vademecum"
            element={
              <ProtectedRoute>
                <Vademecum />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/persona/conciliador-cobranzas"
            element={
              <ProtectedRoute>
                <CollectionsConciliator />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/persona/indicador-permanecia"
            element={
              <ProtectedRoute>
                <PermanencyIndicator />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/personas/bajas"
            element={
              <ProtectedRoute>
                <LowMember />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/empresas/listado"
            element={
              <ProtectedRoute>
                <Financers />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/notificaciones"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/configuracion/planes"
            element={
              <ProtectedRoute>
                <Plans />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/configuracion/channels-dashboard"
            element={
              <ProtectedRoute>
                <ChannelsDashboard />
              </ProtectedRoute>
            }
          />
        )}
        <Route exact path="/venta/:id" element={<SaleTestForm />} />
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/configuracion/email-blacklist"
            element={
              <ProtectedRoute>
                <EmailBlacklist />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/configuracion/bin-blacklist"
            element={
              <ProtectedRoute>
                <BinBlacklist />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/configuracion/validadores"
            element={
              <ProtectedRoute>
                <CardValidators />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/empresas/planes"
            element={
              <ProtectedRoute>
                <FinancerPlans />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/empresas/convenios"
            element={
              <ProtectedRoute>
                <Agreements />
              </ProtectedRoute>
            }
          />
        )}
        {userRole === roles.ROLE_OPERATOR && (
          <Route
            exact
            path="/obra-social/socios"
            element={
              <ProtectedRoute>
                <CollapsibleTable />
              </ProtectedRoute>
            }
          />
        )}
        {/* {(userRole === roles.ROLE_OPERATOR ||
          userRole === roles.ROLE_GIGARED) && (
          <Route
            exact
            path="/canales/gigared"
            element={
              <ProtectedRoute>
                <GigaRed />
              </ProtectedRoute>
            }
          />
        )} */}
        <Route
          exact
          path="/personas/profesionales"
          element={
            <ProtectedRoute>
              <Profetionals />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/reportes"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        {/* Catch-all: cualquier ruta que no matchee muestra el 404 */}
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <NotFound />
            </ProtectedRoute>
          }
        />
         <Route
          exact
          path="/bajas_datos"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
